// extracted by mini-css-extract-plugin
export default {"preview":"ksX2r","caption":"tKIRV"};